import qs from 'querystring'

import { isEmpty } from './lodash'

export const getRoomName = () => {
    let roomName = window.location.pathname
    roomName = roomName.split('/')[1]
    return roomName
}

export const isRoomSetForRecording = (roomName, scheduledClasses = []) => {
    if (!scheduledClasses.length || !roomName) return false

    let start = 0,
        end = scheduledClasses.length - 1,
        isRecording = false
    while (start <= end) {
        let i = scheduledClasses[start]
        let j = scheduledClasses[end]

        isRecording =
            i.ohm_url.includes(roomName) || j.ohm_url.includes(roomName)

        if (isRecording) break

        start += 1
        end -= 1
    }

    return isRecording
}

export const classStore = {
    set: val => localStorage.setItem('class', val),
    get: () => localStorage.getItem('class'),
}

export const extractRoomNameFromURL = roomUrl => {
    let roomName

    const { pathname, search } = new URL(
        roomUrl.startsWith('http') ? roomUrl : `https://${roomUrl}`
    )

    if (!isEmpty(search)) {
        // url contains queries, so parsing it to get value
        const queries = qs.parse(
            search.startsWith('?') ? search.slice(1) : search
        )

        if (!isEmpty(queries.next)) {
            roomName = queries.next
        }
    }

    if (!roomName && !isEmpty(pathname)) {
        // get room name from pathname
        roomName = pathname.replace(/\//g, '')
    }

    console.log('roomName :- ', roomName)

    return roomName
}
